import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

import { StyledIndications } from "../../../styled";

export const StyledMessageTitle = styled(StyledIndications)`
    width: 80%;
    margin-top: 1.6rem;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
`;

export const StyledPRelativeXs = styled.div`
    @media ${breakpoints.xs} {
        position: relative !important;
        margin-top: 2.5rem;
    }
`;
